import { Route, useHistory } from "react-router-dom";

import { IRoute } from "@interfaces";
import { AppLayout } from "@layouts";
import React from "react";
import { selectAuth, useAppSelector } from "@redux";
import { authRouteEnums } from "@enums";

export const ComponentAppRoute = (props: IRoute) => {
    // redux store
    const auth = useAppSelector(selectAuth);
    const { tokenInfoAuth } = auth;
    // hooks
    const history = useHistory();
    // props
    const { path, exact,isProtected } = props;
    //page variable
    const Component = props.component;
    const Layout = props.layout || AppLayout;
    React.useLayoutEffect(() => {
        if (!tokenInfoAuth && isProtected) {
            history.push(authRouteEnums.PATH_SIGNIN);
        }
    }, [tokenInfoAuth, history]);
    return (
        <Route
            path={path}
            exact={exact}
            render={() => (
                <Layout>
                    <Component />
                </Layout>
            )}
        />
    );
};
